var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0233 3.39453C10.1616 3.39453 7.02331 6.53286 7.02331 10.3945V13.7662C7.02331 14.4779 6.71998 15.5629 6.35831 16.1695L5.01665 18.3979C4.18831 19.7745 4.75998 21.3029 6.27665 21.8162C11.305 23.4962 16.73 23.4962 21.7583 21.8162C23.17 21.3495 23.7883 19.6812 23.0183 18.3979L21.6766 16.1695C21.3266 15.5629 21.0233 14.4779 21.0233 13.7662V10.3945C21.0233 6.54453 17.8733 3.39453 14.0233 3.39453Z",
    stroke: "#403D3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1817 3.73367C15.82 3.62867 15.4467 3.54701 15.0617 3.50034C13.9417 3.36034 12.8683 3.44201 11.865 3.73367C12.2033 2.87034 13.0433 2.26367 14.0233 2.26367C15.0033 2.26367 15.8433 2.87034 16.1817 3.73367Z",
    stroke: "#403D3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5233 22.2363C17.5233 24.1613 15.9483 25.7363 14.0233 25.7363C13.0666 25.7363 12.18 25.3397 11.55 24.7097C10.92 24.0797 10.5233 23.193 10.5233 22.2363",
    stroke: "#403D3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellimg);
export default __webpack_public_path__ + "static/media/bellimg.13ff8b2117a61dd2055186409b36fdfa.svg";
export { ForwardRef as ReactComponent };